import { HttpClient } from "@angular/common/http";

import { ChangeDetectorRef, Injectable, Injector, WritableSignal, effect, inject, runInInjectionContext, signal } from "@angular/core";
import { FikoYTService } from "./fikoyt.service";
import { FikoYTEnvIstemci } from "./Environment/environment";
import { IstekOlayTuru } from "./fikoyt.istek.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { Router } from "@angular/router";
import { timeout } from "rxjs";
import { FikoYTIstekKok } from "./modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service";

@Injectable({
    providedIn: 'root',
}) export class KimlikService {
    /** BİLGİ: Aktif Kullanıcı */
    aktifKullaniciJson: WritableSignal<any> = signal<any>(null);
    // $bagliCihazlar: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([null]);
    /** */
    cihazlar: WritableSignal<{ "desktop": number, "machine": number, "mobile": number, "tablet": number, "tv": number }> = signal({ "desktop": 0, "machine": 0, "mobile": 0, "tablet": 0, "tv": 0 });
    /** */
    hataliGirisler: any = [];
    /** */
    $toplamlar: any = null;
    /** */
    // CD: ChangeDetectorRef ;
    /** */
    constructor(private FikoYT: FikoYTService, public CD?: ChangeDetectorRef) {
        // this.CD = inject(ChangeDetectorRef);


        // await this.aktifCihazlarAl();
        // this.aktifCihazlarAl().then();

        // effect(async () => {
        //     this.aktifKullaniciJson;
        //     FikoYT.parametreler["t"] = Math.random().toString();
        //     // if (this.FikoYT.io.bagli()) {
        //     //     // this.$toplamlar = this.FikoYT.io.fromEvent("FikoYT.sistem.cihaz.bağlandı.toplamlar").subscribe(async (data: any) => {
        //     //     //     console.log(data);
        //     //     //     this.cihazlar.set(data[0]);
        //     //     // })
        //     //     // await this.FikoYT.io.gonder("FikoYT.sistem.io.cihaz.baglandi");

        //     // } else {
        //     //     // await this.FikoYT.io.gonder("FikoYT.sistem.io.cihaz.baglandi");
        //     //     // if (this.$toplamlar)
        //     //     //     this.$toplamlar.complete();
        //     //     // this.FikoYT.io.off("FikoYT.sistem.cihaz.bağlandı.toplamlar");
        //     // }
        //     this.FikoYT.io.gonder("FikoYT.sistem.io.cihaz.guncelle");
        // })





    }

    // async aktifCihazlarAl() {

    //     let sonuc: any = await this.FikoYT.io.serverFonksiyon("FikoYT.sistem.bagliCihazlar", this.FikoYT.kimlik.aktifKullaniciJson());
    //     let cihazListesi = { masaustu: 0, mobil: 0, cihaz: 0, saat: 0 };
    //     cihazListesi.masaustu = sonuc.filter((cihaz: any) => {
    //         return cihaz.parametreler[2].degeri?.isDesktop == true;
    //     }).length;
    //     cihazListesi.mobil = sonuc.filter((cihaz: any) => {
    //         return cihaz.parametreler[2].degeri?.isMobile == true;
    //     }).length;

    //     this.cihazlar.set(cihazListesi);

    // }

    async hataliGirislerAl() {
        let sonuc: any = await this.FikoYT.io.serverFonksiyon("FikoYT.sistem.hataliGirisler", this.FikoYT.kimlik.aktifKullaniciJson());

        this.hataliGirisler = sonuc ?? [];
    }


    public async girisYap0(bilgiler: { kullaniciAdi: string, parola: string, [key: string]: any }) {
        let cihaz1 = await this.FikoYT.ayarlar.getByPrimaryKey("cihazBilgiler");
        bilgiler["cihaz"] = cihaz1;
        return await this.FikoYT.istekler.fapisteV1("POST", FikoYTEnvIstemci.adres.serverUrller.girisYap, { vucutParametreler: bilgiler }).toPromise().then(async (data: any) => {

            if (data.durum.hata) {
                throw data;
            }
            data = data.sonuc;
            this.aktifKullaniciJson.set(data);
            // await this.aktifCihazlarAl()

            // this.FikoYT.io.baglan(data)
            // this.FikoYT.io.eventUyeGirisYapti(data);

            await this.FikoYT.ayarlar.ekleYadaGuncelleTek(data, FikoYTEnvIstemci.uygulamaAdi + "-aktifKullanıcı");

            // await this.FikoYT.bildirimTokenKaydet();

            if ('sonraki' in this.FikoYT.activatedRoute.snapshot.queryParams) {
                if (this.FikoYT.activatedRoute.snapshot.queryParams["sonraki"] != '') {
                    await this.FikoYT.router.navigateByUrl(this.FikoYT.activatedRoute.snapshot.queryParams["sonraki"]);
                } else {
                    await this.FikoYT.router.navigateByUrl(FikoYTEnvIstemci.adres.sabitUrller.admin.varsayilanUrl);
                }
            } else {
                /** NOT: Sonraki Parametresi Yok İse Ana Sayfaya Yönlendiriliyor. */
                await this.FikoYT.router.navigateByUrl(FikoYTEnvIstemci.adres.sabitUrller.admin.varsayilanUrl);
            }

            this.FikoYT.parametreler['t'] = Math.random();
            this.FikoYT.degisti.emit();
        },);
    }

    public async girisYap(bilgiler: { kullaniciAdi: string, parola: string, [key: string]: any }) {
        // Eğer bu fonksiyonun DI context'i yoksa, bir DI context oluştur:
        // runInInjectionContext(Injector.create({
        //     providers: [],  // Provider'larını buraya ekleyebilirsin.
        //     parent: undefined  // `parent` olarak undefined kullan.
        // }), () => {


        const formData: FormData = new FormData();
        formData.append('req_body', JSON.stringify(bilgiler));

        this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.giris.yap', { vucutParametreler: formData }).subscribe((snc: any) => {
            if (snc.turu == IstekOlayTuru.Cevaplandi) {
                if (snc.sonuc.body.durum.hata == true) {
                    let hataMesajlari = "";
                    snc.sonuc.body.durum.hatalar.forEach((hata: any) => {
                        hataMesajlari += hata.mesaj + "\n";
                    });

                    this.FikoYT.nzNotification.error("Hatalar Var", hataMesajlari, {
                        nzStyle: {
                            "white-space": "pre-line",
                        }
                    });
                } else {
                    this.FikoYT.nzNotification.success("Giriş Başarılı", "Sisteme Girişiniz Yapılmıştır");

                    this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.aktif-kullanici.bilgi', { vucutParametreler: formData }).subscribe((snc: any) => {
                        if (snc.turu == IstekOlayTuru.Cevaplandi && !snc?.sonuc?.body?.durum?.hata) {
                            setTimeout(() => {
                                this.FikoYT.kimlik.aktifKullaniciJson.set(snc?.sonuc?.body?.sonuc);
                                this.FikoYT.parametreler['t'] = Math.random();
                                this.FikoYT.degisti.emit();
                                setTimeout(() => {
                                    this.FikoYT.io.kop();
                                    this.FikoYT.io.baglan();
                                }, 0);
                            }, 0);
                            // this.CD.detectChanges();

                        }
                    });

                    this.FikoYT.router.navigate(["/"]);
                }
            }
        });
        // });
    }

    public async cikisYap() {
        await this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.cikis.yap',).subscribe((snc: any) => {
            if (snc.turu == IstekOlayTuru.Cevaplandi) {
                if (snc.sonuc.body.durum.hata == true) {
                    let hataMesajlari = "";
                    snc.sonuc.body.durum.hatalar.forEach((hata: any) => {
                        hataMesajlari += hata.mesaj + "\n";
                    });

                    // this.nzNotification.error("Hatalar Var", hataMesajlari, {
                    //     nzStyle: {
                    //         "white-space": "pre-line",
                    //     }
                    // });
                } else {
                    // this.FikoYT.nzNotification.success("Giriş Başarılı", "Sisteme Girişiniz Yapılmıştır");
                    /** */
                    this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.aktif-kullanici.bilgi').subscribe((snc: any) => {
                        if (snc.turu == IstekOlayTuru.Cevaplandi) {
                            if (snc?.sonuc?.body?.durum?.hata != true) {
                                // console.log(snc);
                                setTimeout(() => {
                                    this.FikoYT.kimlik.aktifKullaniciJson.set(snc?.sonuc?.body?.sonuc);
                                    this.FikoYT.parametreler['t'] = Math.random();
                                    this.FikoYT.degisti.emit();
                                    setTimeout(() => {
                                        this.FikoYT.io.kop();
                                        this.FikoYT.io.baglan();
                                    }, 0);
                                }, 0);
                                // this.CD.detectChanges();

                            }
                        }

                    })

                    this.FikoYT.router.navigate(["/"]);
                }
            };
        });

    }

    public async cikisYap0() {
        let cihaz = await this.FikoYT.ayarlar.getByPrimaryKey("cihazBilgiler");

        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var spcook = cookies[i].split("=");
            document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
        }

        // let uye = await this.FikoYT.ayarlar.getByPrimaryKey(FikoYTEnvIstemci.uygulamaAdi + "-aktifKullanıcı");

        await this.FikoYT.ayarlar.ekleYadaGuncelleTek(null, FikoYTEnvIstemci.uygulamaAdi + "-aktifKullanıcı");

        // this.FikoYT.router.navigateByUrl(FikoYTEnvIstemci.adres.sabitUrller.girisVarsayilanUrl);
        return await this.FikoYT.istekler.fapisteV1("POST", FikoYTEnvIstemci.adres.serverUrller.cikisYap, { vucutParametreler: { cihaz: cihaz } }).toPromise().then(async (data: any) => {
            setTimeout(() => {
                // this.FikoYT.io.baglan(data)
                // this.FikoYT.io.eventUyeCikisYapti(this.FikoYT.kimlik.aktifKullaniciJson());

                this.FikoYT.ayarlar.ekleYadaGuncelleTek(null, FikoYTEnvIstemci.uygulamaAdi + "-aktifKullanıcı");
                this.FikoYT.kimlik.aktifKullaniciJson.set(null);
                // await this.FikoYT.bildirimTokenKaydet();
                this.FikoYT.router.navigateByUrl(FikoYTEnvIstemci.adres.sabitUrller.giris.girisVarsayilanUrl);
                this.FikoYT.parametreler['t'] = Math.random();
                this.FikoYT.degisti.emit();
            }, 0);
        }).catch(() => {
            setTimeout(() => {
                this.FikoYT.router.navigateByUrl(FikoYTEnvIstemci.adres.sabitUrller.giris.girisVarsayilanUrl);
                this.FikoYT.kimlik.aktifKullaniciJson.set(null);
                this.FikoYT.parametreler['t'] = Math.random();
                this.FikoYT.degisti.emit();
            }, 0);
        });
    }

}